import React, { useEffect, useState } from 'react';
import styles from '../static/styles/Rewards.module.css';
import weeklyTournamentBg from '../static/img/WeeklyTournaments/imagePubgWeeklyTournament.avif';
import freeFireIcon from '../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif';
import { getRewardsList } from '../api/rewards';
import PremiumPackagePopup from "../components/PremiumPackagePopup";

import MessagePopup from '../components/MessagePopup';
import ArrowLeft from '../static/img/backArrow.png'
import playstation5Img from '../static/img/Rewards/ps5.png';
import asusRogStrixGoImg from '../static/img/Rewards/AsusROGStrixGoUSBCGamingHeadset.avif';
import asusRogDeltaSCoreImg from '../static/img/Rewards/AsusROGDeltaSCoreGamingHeadphone.avif';
import edifierG1Img from '../static/img/Rewards/g2.png';
import edifierG2Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG2.avif';
import asusTufKeyboardImg from '../static/img/Rewards/tufk3rd.png';
import bloodyB760Img from '../static/img/Rewards/b865n.png';
import bloodyB865NImg from '../static/img/Rewards/BloodyMechanicalGamingKeyboardB865N.avif';
import asusGladiusImg from '../static/img/Rewards/gladius3.png';
import asusKerisImg from '../static/img/Rewards/AsusROGKerisP509GamingMouse.avif';
import pubgImg from '../static/img/Rewards/pubguc.png';
import fortniteImg from '../static/img/Rewards/fbuks.png';
import minecraftImg from '../static/img/Rewards/minecraft.png';
import zeroEarbuds from '../static/img/Rewards/zeroEarbuds.png';
import zeroHeadphones from '../static/img/Rewards/zeroHeadphones.png';
import zeroWatch from '../static/img/Rewards/zeroWatch.png';
import freefireDiamonds from '../static/img/Rewards/freefireDiamond.png';
import creditIcon from "../static/img/Home/creditIcon.avif";

import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../api/auth';
import { jwtDecode } from 'jwt-decode';
import GameNowPopup from '../components/GameNowPopup';
import { trackRewardRedemptionAttempt } from '../utils/analytics';


const Rewards = ({ isJcUser }) => {
  const [message, setMessage] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showGameNow, setShowGameNow] = useState(false);
  const [rewardsData, setRewardsData] = useState([]);
  const [loadingRewards, setLoadingRewards] = useState(true);
  const [errorRewards, setErrorRewards] = useState(null);
  const navigate = useNavigate();
  const [showPremiumPopup, setShowPremiumPopup] = useState(false);


  const getRewardImage = (rewardName) => {
    if (!rewardName) return '';
    const name = rewardName.toLowerCase();
    if (name.includes('playstation')) return playstation5Img;
    if (name.includes('asus rog') && name.includes('headphone')) return asusRogDeltaSCoreImg;
    if (name.includes('edifier')) return edifierG1Img;
    if (name.includes('asus') && name.includes('keyboard')) return asusTufKeyboardImg;
    if (name.includes('bloody')) return bloodyB760Img;
    if (name.includes('asus rog') && name.includes('mouse')) return asusGladiusImg;
    if (name.includes('pubg')) return pubgImg;
    if (name.includes('fortnite')) return fortniteImg;
    if (name.includes('minecraft')) return minecraftImg;
    if (name.includes("zero lifestyle headphones")) return zeroHeadphones;
    if (name.includes("zero lifestyle watch")) return zeroWatch;
    if (name.includes("zero lifestyle earbuds")) return zeroEarbuds;
    if (name.includes("free fire")) return freefireDiamonds;
    return '';
  };

  useEffect(() => {
    document.title = "Rewards | Jazz Esl"
  }, [])

  useEffect(() => {
    const loadRewards = async () => {
      try {
        setLoadingRewards(true);
        setErrorRewards(null);
        const response = await getRewardsList();
        if (response && response.data && Array.isArray(response.data)) {
          setRewardsData(response.data);
        } else {
          setRewardsData([]);
        }
      } catch (err) {
        setErrorRewards(err.message || 'Failed to load rewards');
      } finally {
        setLoadingRewards(false);
      }
    };
    loadRewards();
  }, []);

  const handleRedeem = (rewardIndex) => {
    if (!isAuthenticated()) {
      window.location.href = process.env.REACT_APP_LOGIN_URL;
      return;
    }

    if (rewardsData[0]?.free_trial) {
      setMessage("You're currently on a free trial and cannot redeem rewards. Please subscribe to access this feature.");
      setIsPopupOpen(true);
      return;
    }

    const accessToken = sessionStorage.getItem("access_token");
    const decoded = jwtDecode(accessToken);

    if (decoded.gn) {
      if (decoded.gn === 1) {
        setShowGameNow(true);
        return;
      }
    }

    const reward = rewardsData[rewardIndex];
    if (!reward) return;

    const profileData = JSON.parse(sessionStorage.getItem("profileData"));
    const ucredits = profileData?.credits;
    console.log(ucredits)
    const remaingCredits = ucredits - reward.credits;
    trackRewardRedemptionAttempt(reward.name, reward.id, reward.credits);
    navigate('/redeem', { state: { reward, gtagItemName: reward.name, ucredits: ucredits, leftCreds: remaingCredits, rImg: getRewardImage(reward.name) } });
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setMessage(null);
  };

  const renderCard = (reward, index) => (
    <> <div className={styles.cardLeft}> <div className={styles.imageBox}> <img
      src={getRewardImage(reward.name)}
      alt=""
      className={styles.rewardImage}
    /> </div>


      <span className={styles.cardType}>
        {reward.game ? 'CURRENCY' : 'KEYBOARD'}
      </span>
    </div>

      <div className={styles.cardRight}>

        <div className={styles.topRow}>
          <span className={styles.premiumBadge}>
            PREMIUM
          </span>

          <div className={styles.smallPrice}>
            🪙 {reward.credits?.toLocaleString()}
          </div>
        </div>

        <div className={styles.rewardInfo}>
          <span className={styles.rewardBrand}>
            {reward.game || 'ASUS'}
          </span>

          <h4 className={styles.rewardName}>
            {reward.name}
          </h4>
        </div>

        <div className={styles.bottomRow}>
          <div className={styles.creditRequired}>
            CREDITS REQUIRED
          </div>

          <button
            className={styles.redeemBtn}
            onClick={() => handleRedeem(index)}
            disabled={!reward.can_redeem}
          >
            REDEEM NOW →
          </button>
        </div>
      </div>
    </>


  );
  {/* ===== SORT + RENDER ===== */ }

  const getCategory = (reward) => {
    const name = reward.name?.toLowerCase() || '';
    const game = reward.game?.toLowerCase() || '';

    if (name.includes('keyboard')) return 'keyboards';
    if (name.includes('head')) return 'headphones';
    if (name.includes('mouse')) return 'mouse';
    if (name.includes('earbuds')) return 'earbuds';
    if (name.includes('watch')) return 'watches';
    if (name.includes('pubg')) return 'pubg';
    if (name.includes('free fire')) return 'freefire';
    if (name.includes('minecraft')) return 'minecraft';
    if (name.includes('fortnite')) return 'fortnite';

    if (game) return 'currency';

    return 'other';
  };

  const sortedRewards = [...rewardsData.slice(1)].sort((a, b) => {
    const order = {
      earbuds: 1,
      headphones: 2,
      mouse: 3,
      watches: 4,
      keyboards: 5,
      pubg: 6,
      freefire: 7,
      minecraft: 8,
      fortnite: 9,
      other: 9
    };

    return order[getCategory(a)] - order[getCategory(b)];
  });
  return (
    <div className={styles.container}>
      <div className={styles.navigationHeader}>
        <div
          className={styles.navigationBack}
          onClick={() => navigate(-1)}
        >
          <img src={ArrowLeft} alt="<" />
        </div>
        <div className={styles.navigationTitle}>
          <p>Game currencies</p>
          <h2 className={styles.heading}>Rewards</h2>
        </div>
      </div>

      {/* WALLET */}
      {/* <div className={styles.walletCard}>
            <div>
                <span className={styles.walletLabel}>YOUR WALLET</span>
                <h3 className={styles.walletCredits}>12,463 credits</h3>
            </div>

            <div className={styles.weeklyBox}>
                <span>TASKS THIS WEEK</span>
                <strong>+450 earned</strong>
            </div>
        </div> */}

      <div className={styles.cardGrid}>
        {/* FEATURED */}
        {rewardsData[0] && (
          <div className={styles.featuredCard}>

            <div className={styles.featuredGlow}></div>

            <div className={styles.featuredContent}>

              <div className={styles.featuredBadges}>
                <span className={styles.yellowBadge}>⭐ TOP REDEEM</span>
                {/* <span className={styles.redBadge}>🔴 LIMITED STOCK</span> */}
              </div>

              <span className={styles.brand}>SONY</span>

              <h2 className={styles.ps5Title}>PS5</h2>

              <p className={styles.ps5Subtitle}>
                PlayStation 5 Slim Console
              </p>

              <div className={styles.featuredFooter}>
                <div className={styles.creditPill}>
                  <img src={creditIcon} alt="🪙" />
                  {rewardsData[0].credits?.toLocaleString()}
                </div>

                <button
                  className={styles.redeemHeroBtn}
                  // onClick={() => handleRedeem(0)}
                  onClick={() => {
                    if (!isJcUser) {
                      setShowPremiumPopup(true);
                    } else {
                      handleRedeem(0);
                    }
                  }}


                  disabled={!rewardsData[0].can_redeem}
                >
                  {rewardsData[0].can_redeem ? "REDEEM NOW →" : "INSUFFICIENT COINS"}
                </button>
              </div>
            </div>

            <div className={styles.featuredImageWrap}>
              <img
                src={getRewardImage(rewardsData[0].name)}
                alt=""
                className={styles.featuredImage}
              />
            </div>
          </div>
        )}

        {/* REWARDS */}
        <div className={styles.rewardSections}>

          {sortedRewards.map((reward, index) => {

            const lower = reward.name?.toLowerCase() || '';
            const game = reward.game?.toLowerCase() || '';

            let categoryClass = styles.orangeCard;

            // 🔴 BLOODY (RED)
            if (lower.includes('bloody')) {
              categoryClass = styles.bloodyCard;
            }

            // 🟢 EDIFIER (GREEN + PINK MIX)
            else if (lower.includes('edifier')) {
              categoryClass = styles.edifierCard;
            }

            // 🎧 OTHER HEADPHONES (PURE GREEN)
            else if (lower.includes('head')) {
              categoryClass = styles.pinkCard;
            }

            // 🖱️ MOUSE
            else if (lower.includes('mouse')) {
              categoryClass = styles.goldCard;
            }

            // 🎮 GAME COLORS
            else if (game.includes('pubg')) {
              categoryClass = styles.pubgCard;
            }
            else if (game.includes('fortnite')) {
              categoryClass = styles.fortniteCard;
            }
            else if (game.includes('minecraft')) {
              categoryClass = styles.minecraftCard;
            }
            else if (game.includes('freefire')) {
              categoryClass = styles.freefireCard;
            }

            // CURRENCY fallback (if no specific game match)
            else if (reward.game) {
              if (index % 4 === 0) categoryClass = styles.blueCard1;
              else if (index % 4 === 1) categoryClass = styles.blueCard2;
              else if (index % 4 === 2) categoryClass = styles.blueCard3;
              else categoryClass = styles.blueCard4;
            }

            const currentCategory = getCategory(reward);
            const previousCategory =
              index > 0 ? getCategory(sortedRewards[index - 1]) : null;

            const showCategoryHeader = currentCategory !== previousCategory;

            return (
              <React.Fragment key={reward.id || reward.name}>
                {showCategoryHeader && (
                  <h1 className={styles.categoryTitle}>
                    {`${currentCategory.toUpperCase()}`}
                  </h1>
                )}
                <div>
                  <div
                    key={reward.id || reward.name}
                    className={`${styles.rewardCard} ${categoryClass}`}
                  >

                    {/* LEFT */}

                    <div className={styles.cardLeft}>
                      <div className={styles.imageBox}>
                        <img
                          src={getRewardImage(reward.name)}
                          alt=""
                          className={styles.rewardImage}
                        />
                      </div>

                      <span className={styles.cardType}>
                        {reward.game ? 'CURRENCY' : getCategory(reward).toUpperCase() }
                      </span>
                    </div>

                    {/* RIGHT */}
                    <div className={styles.cardRight}>

                      <div className={styles.topRow}>
                        <div className={styles.creditRequired}>
                          CREDITS REQUIRED
                        </div>


                        <div className={styles.smallPrice}>
                          <img src={creditIcon} alt="" /> {reward.credits?.toLocaleString()}
                        </div>
                      </div>

                      <div className={styles.rewardInfo}>
                        <span className={styles.rewardBrand}>
                          {reward.game || ''}
                        </span>

                        <h4 className={styles.rewardName}>
                          {reward.name}
                        </h4>
                      </div>

                      <div className={styles.bottomRow}>

                        <span className={styles.premiumBadge}>
                          {reward.game === null ? 'PREMIUM' : 'STANDARD'}
                        </span>

                        <button
                          className={styles.redeemBtn}
                          // onClick={() =>
                          //     reward.can_redeem &&
                          //     handleRedeem(
                          //         rewardsData.findIndex(r => r.id === reward.id)
                          //     )
                          // }
                          onClick={() => {
                            if (!isJcUser && reward.game == null) {
                              setShowPremiumPopup(true);
                            } else {
                              reward.can_redeem &&
                                handleRedeem(
                                  rewardsData.findIndex(r => r.id === reward.id)
                                );
                            }
                          }}
                          disabled={!reward.can_redeem}
                        >
                          {reward.can_redeem
                            ? "REDEEM NOW →"
                            : "INSUFFICIENT COINS"}
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}

        </div>

        {isPopupOpen && (
          <MessagePopup
            isOpen={isPopupOpen}
            message={message}
            onClose={handleClosePopup}
          />
        )}

        {showGameNow && (
          <GameNowPopup
            isOpen={showGameNow}
            onClose={() => setShowGameNow(false)}
          />
        )}
      </div>
      <PremiumPackagePopup
        isOpen={showPremiumPopup}
        onClose={() => setShowPremiumPopup(false)}
      />
    </div>


  );

};

export default Rewards;